import gql from 'graphql-tag';

export const HomeRecentWorkQuery = gql`
	query useHomeRecentWorkDataQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: { products: ["CONFLUENCE"], objectTypes: $objectTypes }
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
								}
							}
							event {
								id
								timestamp
								eventType
							}
						}
					}
				}
			}
		}
	}
`;
